import { ReactNode } from 'react'

export type PageLayoutProps = {
  children?: ReactNode
}

export function PageLayout({ children }: PageLayoutProps) {

  return (
    <div className="w-full h-full flex justify-center">
      <div className="max-w-6xl w-full h-full p-stack-roomy">
        { children }
      </div>
    </div>
  )
}
